import { getCookie } from 'cookies-next';

import { useAuthState } from '@contexts/auth/AuthContext';

const useToken = (): string => {
  const { loginInfo } = useAuthState();

  let token = '';

  if (typeof loginInfo?.token === 'string' && loginInfo.token.trim() !== '') {
    // Eğer loginInfo.token bir string ve boş değilse
    token = loginInfo.token;
  } else {
    // Eğer loginInfo.token geçerli değilse cookie'den al
    const cookieToken = getCookie('token');
    token = typeof cookieToken === 'string' ? cookieToken : '';
  }

  return token;
};
export default useToken;
